export default __webpack_public_path__ + "static/media/Detail-Sistem-Manajemen.d9ddbe0d.png";